<script setup>
import { useI18n } from 'vue-i18n';
import Input from 'dashboard/components-next/input/Input.vue';
import Select from 'dashboard/components-next/select/Select.vue';
import Switch from 'dashboard/components-next/switch/Switch.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const params = defineModel({ type: Array, default: () => [] });
const { t } = useI18n();
const MAX_PARAMS = 8;

const typeOptions = [
  { value: 'string', label: 'string' },
  { value: 'integer', label: 'integer' },
  { value: 'number', label: 'number' },
  { value: 'boolean', label: 'boolean' },
];

const addParam = () => {
  if (params.value.length >= MAX_PARAMS) return;
  params.value = [
    ...params.value,
    { name: '', type: 'string', description: '', required: true },
  ];
};

const removeParam = index => {
  params.value = params.value.filter((_, itemIndex) => itemIndex !== index);
};
</script>

<template>
  <div class="flex flex-col gap-3">
    <p class="text-sm text-n-slate-12">{{ t('ARROWS_AI.TOOLS.PARAMS') }}</p>
    <div
      v-for="(param, index) in params"
      :key="index"
      class="flex flex-col gap-2 p-3 border rounded-lg border-n-weak"
    >
      <div class="grid grid-cols-1 gap-2 sm:grid-cols-2">
        <Input v-model="param.name" :label="t('ARROWS_AI.TOOLS.PARAM_NAME')" />
        <div class="flex flex-col gap-1">
          <span class="text-sm text-n-slate-12">{{
            t('ARROWS_AI.TOOLS.PARAM_TYPE')
          }}</span>
          <Select v-model="param.type" :options="typeOptions" />
        </div>
      </div>
      <Input
        v-model="param.description"
        :label="t('ARROWS_AI.TOOLS.PARAM_DESCRIPTION')"
      />
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-2">
          <span class="text-sm text-n-slate-12">{{
            t('ARROWS_AI.TOOLS.PARAM_REQUIRED')
          }}</span>
          <Switch v-model="param.required" />
        </div>
        <Button
          type="button"
          variant="ghost"
          color="ruby"
          size="sm"
          icon="i-lucide-trash"
          :label="t('ARROWS_AI.TOOLS.DELETE')"
          @click="removeParam(index)"
        />
      </div>
    </div>
    <Button
      v-if="params.length < MAX_PARAMS"
      type="button"
      variant="faded"
      color="slate"
      :label="t('ARROWS_AI.TOOLS.PARAM_ADD')"
      @click="addParam"
    />
  </div>
</template>
